export default __webpack_public_path__ + "static/media/vitalik_nft_20.92ad8cf8.svg";